<template>
  <v-container bg fill-height grid-list-md text-xs-center>
    <v-layout row wrap align-center>
      <v-flex>
        <div class="headline grey--text">
          {{$t('rms.admin.panel.user_impersonation.confirmation', {
                    user_name: user.name
                  })}}
        </div>
         <v-btn outline  class="mt-3" color="green" :to="{name:'AdminUserList'}">{{ $t('rms.admin.go_back') }}</v-btn>
        <v-btn @click="confirm()"  outline class="mt-3" color="primary">{{ $t('rms.admin.impersonation.start') }}</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    user() {
      return this.$store.getters["adminUser/getUserFromId"](
        this.$route.params.user_id
      );
    }
  },

  methods: {
    async confirm() {
     try {
        await this.$store.dispatch("impersonation/impersonate", {
          user_id: this.$route.params.user_id
        });
     }catch(error) {
       this.$store.dispatch('app/showMessage', {
         message: error.message,
         color:'error'
       })
     }
    }
  }
};
</script>

<style>
</style>
